import React, { useRef, useState } from "react";
import { ReactComponent as AddIcon } from "../../../../../assets/images/icons/add.svg";
import { ReactComponent as MedicalIcon } from "../../../../../assets/images/icons/medical_services.svg";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { drugTestTablecoloumn } from "../Data";
import { Popup } from "devextreme-react";
import { AddDrugTest } from "./AddDrugTest";
import { RandomTesting } from "./RandomTesting";
import { DoNotCreateObligation } from "./DoNotCreateObligation";
import { ApiError } from "../../../../Error/ApiError";
import { VoidPopup } from "../VoidPopup";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../../../../components/Logout";
import axios from "axios";
import { handleGetLocal } from "../../../../../services/auth-service";

export const DrugTest = ({
  toastConfig,
  setToastConfig,
  userinfo,
  dropdownData,
  docketDropdownData,
  docketfield,
  drugTestData,
  drugTestErrorHandling,
  getrugTestDataApi,
  getDrugTestData,
  dockertDetail,
  gotoDrugTest,
}) => {
  const [loading, setLoading] = useState(false);
  const [addDrugTest, setAddDrugTest] = useState(false);
  const [randomTesting, setRandomTesting] = useState(false);
  const [doNotCreateObligation, setDoNotCreateObligation] = useState(false);
  const [voidPopup, setVoidPopup] = useState(false);
  const [drugTestRowData, setDrugTestRowData] = useState([]);
  const [drugTestType, setDrugTestType] = useState("");
  const [drugDropdownData, setDrugDropdownData] = useState({});
  const [existingDocketDropdownData, setExistingDocketDropdownData] = useState([]);
  const [amount, setAmount] = useState(null);
  const navigate = useNavigate();
  const pathname = handleGetLocal("pathURL");

  const [addRecurringDrugTestEnabled, setAddRecurringDrugTestEnabled] = useState(false);
  const [companyOptionLoading, setCompanyOptionLoading] = useState(true);
  const [obligationPayload, setObligationPayload] = useState(null);
  const [drugDropdownLoading, setDrugDropdownLoading] = useState(false);

  const getAddRecurringDrugTestOption = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Account/getCompanyOption?Name=Add Recurring Drug Test`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      );

      const optionValue = response?.data?.data;

      setAddRecurringDrugTestEnabled(
        String(optionValue ?? "")
          .trim()
          .toLowerCase() === "true",
      );
    } catch (error) {
      console.error("Error fetching Add Recurring Drug Test option:", error);
      setAddRecurringDrugTestEnabled(false);

      if (error?.response?.status === 401) {
        logOut();
      }
    } finally {
      setCompanyOptionLoading(false);
    }
  };

  useEffect(() => {
    getAddRecurringDrugTestOption();
  }, [pathname]);

  const getDrugTestDropdownData = async (signal) => {
    const docketId = dockertDetail?.id;
    const personId = userinfo?.gPersonId;

    if (!docketId && !personId) {
      setDrugDropdownData({});
      return;
    }

    setDrugDropdownLoading(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/DrugTest/drugTestDropdownAsync`, {
        params: {
          ...(personId && { personId }),
          ...(docketId && { docketId }),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
        signal,
      });

      setDrugDropdownData(response?.data?.isSuccess ? (response?.data?.data ?? {}) : {});
    } catch (error) {
      if (error?.code !== "ERR_CANCELED" && error?.name !== "CanceledError" && !signal?.aborted) {
        setDrugDropdownData({});

        if (!error?.response) {
          navigate("/error/500");
        } else if (error.response.status === 401) {
          logOut();
        }
      }
    } finally {
      if (!signal?.aborted) {
        setDrugDropdownLoading(false);
      }
    }
  };
  const url =
    gotoDrugTest && dockertDetail
      ? `api/DrugTest/getExistingObligation?personId=${userinfo?.gPersonId}&docketId=${dockertDetail.id}`
      : `api/DrugTest/getExistingObligation?personId=${userinfo?.gPersonId}`;

  const getExistingDocketDropdownData = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/${url}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setExistingDocketDropdownData(val?.data?.data);
      })
      .catch((error) => {
        if (!error?.response) {
          navigate(`/error/500`);
        } else if (error?.response?.status === 401) {
          logOut();
        }
      });
  };

  // useEffect(() => {
  //   getDrugTestDropdownData();
  //   getExistingDocketDropdownData();
  // }, [dockertDetail?.id, drugTestRowData?.gDocketId]);

  useEffect(() => {
    const controller = new AbortController();

    setDrugDropdownData({});
    setExistingDocketDropdownData([]);

    getDrugTestDropdownData(controller.signal);
    getExistingDocketDropdownData();

    return () => {
      controller.abort();
    };
  }, [dockertDetail?.id, userinfo?.gPersonId, userinfo?.sOffenderNumber]);

  useEffect(() => {
    setRandomTesting(false);
    setAddDrugTest(false);
    setDoNotCreateObligation(false);
    setVoidPopup(false);

    setDrugTestRowData([]);
  }, [dockertDetail?.id, userinfo?.gPersonId, userinfo?.sOffenderNumber]);

  const handleRecurringDrugTestContinue = (payload) => {
    setObligationPayload(payload);
    setAddDrugTest(false);
    setDoNotCreateObligation(true);
  };

  return (
    <>
      <Popup
        visible={addDrugTest}
        onHiding={() => {
          setAddDrugTest(false);
        }}
        showTitle={false}
        width={768}
        // height={560}
        height="auto"
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddDrugTest
          addDrugTest={addDrugTest}
          setAddDrugTest={setAddDrugTest}
          userinfo={userinfo}
          dropdownData={dropdownData}
          docketDropdownData={docketDropdownData}
          setLoading={setLoading}
          setAmount={setAmount}
          amount={amount}
          existingDocketDropdownData={existingDocketDropdownData}
          gotoDrugTest={gotoDrugTest}
          dockertDetail={dockertDetail}
          SetDoNotCreateObligation={handleRecurringDrugTestContinue}
        />
      </Popup>
      <Popup
        visible={randomTesting}
        onHiding={() => {
          setRandomTesting(false);
        }}
        showTitle={false}
        width={900}
        // height={600}
        height={829}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <RandomTesting
          key={`${dockertDetail?.id}-${userinfo?.gPersonId}-${userinfo?.sOffenderNumber}`}
          randomTesting={randomTesting}
          setRandomTesting={setRandomTesting}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          userinfo={userinfo}
          docketDropdownData={docketDropdownData}
          drugDropdownData={drugDropdownData}
          gotoDrugTest={gotoDrugTest}
          dockertDetail={dockertDetail}
          getDrugTestDropdownData={getDrugTestDropdownData}
        />
      </Popup>
      <Popup
        visible={doNotCreateObligation}
        onHiding={() => {
          setDoNotCreateObligation(false);
        }}
        showTitle={false}
        width={768}
        // height={650}
        height="auto"
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <DoNotCreateObligation
          doNotCreateObligation={doNotCreateObligation}
          setDoNotCreateObligation={setDoNotCreateObligation}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          userinfo={userinfo}
          docketDropdownData={docketDropdownData}
          docketfield={docketfield}
          setLoading={setLoading}
          loading={loading}
          drugTestRowData={drugTestRowData}
          drugTestType={drugTestType}
          drugDropdownData={drugDropdownData}
          getrugTestDataApi={getrugTestDataApi}
          amount={amount}
          setAddDrugTest={setAddDrugTest}
          gotoDrugTest={gotoDrugTest}
          dockertDetail={dockertDetail}
          obligationPayload={obligationPayload ?? {}}
          getDrugTestData={getDrugTestData}
        />
      </Popup>
      <Popup
        visible={voidPopup}
        onHiding={() => {
          setVoidPopup(false);
        }}
        showTitle={false}
        width={800}
        height={450}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <VoidPopup
          setVoidPopup={setVoidPopup}
          voidHeading="Void Drug Test"
          voidSubHeading="Void Drug Test"
          setLoad={setLoading}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          filedId={drugTestRowData?.gDrugTestId}
          fieldName="gDrugTestId"
          apiURl="DrugTest/voidDrugTest"
          refreshApi={getrugTestDataApi}
          userinfo={userinfo}
          comment="Comments"
        />
      </Popup>
      <div className="drug_test">
        <div className="buttons" style={{ paddingTop: "10px", paddingLeft: "10px" }}>
          <button
            className="btn"
            disabled={companyOptionLoading}
            onClick={() => {
              setDrugTestType("ADD");
              setAmount(null);
              setObligationPayload(null);

              if (addRecurringDrugTestEnabled) {
                setAddDrugTest(true);
                setDoNotCreateObligation(false);
              } else {
                setAddDrugTest(false);
                setDoNotCreateObligation(true);
              }
            }}
            style={{
              width: "auto",
              opacity: companyOptionLoading ? 0.6 : 1,
              cursor: companyOptionLoading ? "not-allowed" : "pointer",
            }}
          >
            Add Drug Test <AddIcon className="svg-blue-white" />
          </button>
          {gotoDrugTest && (
            <button
              className="btn"
              onClick={() => {
                setRandomTesting(true);
              }}
              style={{ width: "auto" }}
            >
              Random Testing <MedicalIcon className="svg-blue-white" />
            </button>
          )}
        </div>
        {drugTestErrorHandling ? (
          <ApiError />
        ) : (
          <div className="drugtest_table" style={{ paddingLeft: "10px" }}>
            <Table1
              editTable={false}
              height={"auto"}
              Tablecoloum={drugTestTablecoloumn}
              tableRow={drugTestData?.map((val, i) => {
                return { ...val, ID: i };
              })}
              load={loading}
              coloumWidthText={"DrugTest"}
              mandatoryColoum={"Docket #"}
              setVoidPopup={setVoidPopup}
              setDoNotCreateObligation={setDoNotCreateObligation}
              drugTestMenu={true}
              setDrugTestRowData={setDrugTestRowData}
              setDrugTestType={setDrugTestType}
              setVoideFalse={true}
            />
          </div>
        )}
      </div>
    </>
  );
};
